import API from '@/views/Fdc/Apis'
import _ from 'lodash'
import BriqueChart from '@/components/BriqueChart/BriqueChart.js'

/**
 * Analysis > Multivariate Analysis - PCA
 * PCA Tab
 */
export default {
  name: 'PCA',
  components: {
  },
  mounted () {
    // chart 중심 반경 원을 그리기 위한 function series
    // this.pFun = new wjChartAnalytics.ParametricFunctionSeries()
    // this.scoreChart.series.push(this.pFun)
    this.briqueChart = BriqueChart
  },
  computed: {
  },
  watch: {
    /**
     * summaryData 변화 감지
     */
    summaryData () {
      this.chartData1 = []
      this.chartData2 = []
      this.chartData3 = []
      this.cumulativePercent = 90
      // this.pFun.min = 0
      // this.pFun.max = 0
    }
  },
  props: {
    summaryData: {
      type: Object,
      default () {
        return null
      }
    }
  },
  methods: {
    /**
     * 검색 Validation
     * @returns {Boolean} validation 성공 여부
     */
    _searchValidation () {
      if (!(this.summaryData.selectedVariables != null && Object.keys(this.summaryData.selectedVariables).length > 0)) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['features']))
        return true
      }
      return false
    },
    /**
     * PCA Traning Model 조회
     */
    async searchTraningModel () {
      if (this._searchValidation()) {
        return
      }
      this.summaryData.cumulativePercent = this.cumulativePercent * 0.01
      const payload = {
        dataList: this.summaryData,
        modelType: 'mva'
      }
      await API.Analysis.runPcaTrain(payload, this.callback)
    },
    /**
     * PCA Traning Model 조회 callback
     * @param {Object} searchData PCA Traning Model 조회 결과
     */
    callback (searchData) {
      this.summaryData.trainingModel = searchData.trainingModel
      this.summaryData.buildJsonStr = searchData.buildJsonStr
      const trainingModel = _.clone(this.summaryData.trainingModel)
      // for (var i in this.summaryData.selectedVariables) {
      //   let variable = this.summaryData.selectedVariables[i]
      //   let variableSplit = variable.split('.')
      //   trainingModel.loadingList[i].paramName = variableSplit[0]
      //   trainingModel.loadingList[i].stepId = variableSplit[1]
      //   trainingModel.loadingList[i].summaryType = variableSplit[2]
      // }
      // for (let j in this.summaryData.summaryDataList.datas) {
      //   let data = this.summaryData.summaryDataList.datas[j]
      //   trainingModel.scoreList[j].endDt = data.endDt
      //   trainingModel.scoreList[j].lotId = data.lotId
      //   trainingModel.scoreList[j].substId = data.substId
      // }
      // this.drawScreePlot(trainingModel.cumulativeList)
      this.drawScreePlot(trainingModel.cumulativeChart)
      // this.drawLoadingChart(trainingModel.loadingList)
      this.drawLoadingChart(trainingModel.loadingChart)
      // this.drawScoreChart(trainingModel.scoreList, trainingModel.ellipse)
      this.drawScoreChart(trainingModel.scoreChart, trainingModel.ellipse)

      // this.chartData1 = trainingModel.cumulativeList
      // this.chartData2 = trainingModel.loadingList
      // this.chartData3 = trainingModel.scoreList

      // this.scoreEllipse = trainingModel.ellipse

      // this.drawChart()
    },
    drawScreePlot (traces) {
      traces.map(trace => {
        if (trace.name === 'NUMBER OF PC') {
          trace.type = 'bar'
        } else {
          trace.yaxis = 'y2'
          trace.showlegend = false
        }
        trace.hovertemplate = '<b>Index:</b> %{text.index}<br><b>Cumulated:</b> %{text.cumulated:.4f}<br><b>variation:</b> %{text.variation:.4f}<extra></extra>'
      })
      // let traces = [
      //   {
      //     name: 'NUMBER OF PC',
      //     type: 'bar',
      //     x: data.map(element => element.index),
      //     y: data.map(element => element.variation),
      //     hovertemplate: '<b>Index:</b> %{text.index}<br><b>Cumulated:</b> %{text.cumulated}<br><b>variation:</b> %{text.variation}<extra></extra>',
      //     text: data.map(e => {
      //       return {
      //         index: e.index,
      //         cumulated: Math.round(e.cumulated * 10000) / 10000.0,
      //         variation: Math.round(e.variation * 10000) / 10000.0
      //       }
      //     })
      //   }, {
      //     name: 'Cumulated',
      //     x: data.map(element => element.index),
      //     y: data.map(element => element.cumulated),
      //     yaxis: 'y2',
      //     hovertemplate: '<b>Index:</b> %{text.index}<br><b>Cumulated:</b> %{text.cumulated}<br><b>variation:</b> %{text.variation}<extra></extra>',
      //     text: data.map(e => {
      //       return {
      //         index: e.index,
      //         cumulated: Math.round(e.cumulated * 10000) / 10000.0,
      //         variation: Math.round(e.variation * 10000) / 10000.0
      //       }
      //     }),
      //     showlegend: false
      //   }
      // ]
      let layout = {
        title: this.$t('fdc.FAULT_DETECTION.LABEL.PCA_CUMULATIVE_CHART'),
        legend: {
          orientation: 'h'
        },
        yaxis2: {
          side: 'right',
          overlaying: 'y'
        },
        hoverlabel: {
          align: 'left'
        }
      }
      let config = {
        responsive: true,
        scrollZoom: true,
        displaylogo: false,
        displayModeBar: true
      }
      BriqueChart.newPlot('screePlot', traces, layout, config)
    },
    drawLoadingChart (traces) {
      traces.map(trace => {
        trace.mode = 'markers'
        trace.type = 'scattergl'
        trace.hovertemplate = '<b>Parameter Name:</b> %{text.paramName}<br><b>Step Id:</b> %{text.stepId}<br><b>Summary Type:</b> %{text.summaryType}<br><b>PC1 value:</b> %{x:.4f}<br><b>PC2 value:</b> %{y:.4f}<extra></extra>'
      })

      // let traces = [
      //   {
      //     name: 'Loading',
      //     mode: 'markers',
      //     type: 'scattergl',
      //     x: data.map(element => element.pc1),
      //     y: data.map(element => element.pc2),
      //     hovertemplate: '<b>Parameter Name:</b> %{text.paramName}<br><b>Step Id:</b> %{text.stepId}<br><b>Summary Type:</b> %{text.summaryType}<br><b>PC1 value:</b> %{text.pc2}<br><b>PC2 value:</b> %{text.pc1}<extra></extra>',
      //     text: data.map(e => {
      //       return {
      //         paramName: e.paramName ? e.paramName : 'undefined',
      //         stepId: e.stepId ? e.stepId : 'undefined',
      //         summaryType: e.summaryType ? e.summaryType : 'undefined',
      //         pc1: Math.round(e.pc1 * 10000) / 10000.0,
      //         pc2: Math.round(e.pc2 * 10000) / 10000.0
      //       }
      //     })
      //   }
      // ]
      let xList = [...traces[0].x.map(data => Math.abs(Number(data)))]
      let yList = [...traces[0].y.map(data => Math.abs(Number(data)))]
      let layout = {
        title: this.$t('fdc.FAULT_DETECTION.LABEL.LOADING_CHART'),
        xaxis: {
          fixedrange: true,
          range: [
            Math.max(...xList) * -1 * 1.1,
            Math.max(...xList) * 1.1
          ]
        },
        yaxis: {
          fixedrange: true,
          range: [
            Math.max(...yList) * -1 * 1.1,
            Math.max(...yList) * 1.1
          ]
        },
        hoverlabel: {
          align: 'left'
        },
        hovermode: 'closest',
        showlegend: false
      }
      let config = {
        responsive: true,
        scrollZoom: true,
        displaylogo: false,
        displayModeBar: true
      }
      BriqueChart.newPlot('loadingChart', traces, layout, config)
    },
    drawScoreChart (traces, ellipse) {
      traces.map(trace => {
        trace.mode = 'markers'
        trace.type = 'scattergl'
        trace.hovertemplate = '<b>Datetime:</b> %{text.endDt|%Y-%m-%d %H:%M:%S.%L}<br><b>Lot ID:</b> %{text.lotId}<br><b>Substrate ID:</b> %{text.substId}<br><b>PC1 value:</b> %{x:.4f}<br><b>PC2 value:</b> %{y:.4f}<extra></extra>'
      })
      // let traces = [
      //   {
      //     name: 'Score',
      //     mode: 'markers',
      //     type: 'scattergl',
      //     x: data.map(element => element.pc1),
      //     y: data.map(element => element.pc2),
      //     hovertemplate: '<b>Datetime:</b> %{text.Datetime}<br><b>Lot ID:</b> %{text.lotId}<br><b>Substrate ID:</b> %{text.substId}<br><b>PC1 value:</b> %{text.pc2}<br><b>PC2 value:</b> %{text.pc1}<extra></extra>',
      //     text: data.map(e => {
      //       return {
      //         Datetime: e.endDt,
      //         lotId: e.lotId,
      //         substId: e.substId,
      //         pc1: Math.round(e.pc1 * 10000) / 10000.0,
      //         pc2: Math.round(e.pc2 * 10000) / 10000.0
      //       }
      //     })
      //   }
      // ]
      let layout = {
        title: this.$t('fdc.FAULT_DETECTION.LABEL.SCORE_CHART'),
        shapes: [
          {
            type: 'circle',
            xref: 'x',
            yref: 'y',
            x0: ellipse.xradius * Math.cos(Math.PI) + ellipse.mean[0],
            x1: ellipse.xradius * Math.cos(0) + ellipse.mean[0],
            y0: ellipse.yradius * Math.sin(Math.PI / 2 * 3) + ellipse.mean[1],
            y1: ellipse.yradius * Math.sin(Math.PI / 2) + ellipse.mean[1],
            line: {
              color: 'red'
            }
          }
        ],
        hoverlabel: {
          align: 'left'
        },
        hovermode: 'closest',
        showlegend: false
      }
      let config = {
        responsive: true,
        scrollZoom: true,
        displaylogo: false,
        displayModeBar: true
      }
      let promise = BriqueChart.newPlot('scoreChart', traces, layout, config)

      promise.then(() => {
        // spec line에 대한 min max 처리
        let relayout = document.querySelector('#scoreChart').layout
        relayout.xaxis.range = [ellipse.xmin, ellipse.xmax]
        relayout.yaxis.range = [ellipse.ymin, ellipse.ymax]
        BriqueChart.relayout('scoreChart', relayout)
      })
    },
    /**
    * Run Button 클릭
    */
    clickRun () {
      this.searchTraningModel()
    },
    /**
     * 전체 Chart Draw
     */
    // drawChart () {
    //   const marginRatio1 = 0.2; const marginRatio2 = 0.3
    //   this.drawChartYArea(this.screePlotYMinMax, this.chartData1.map(function (o) { return o.variation }), marginRatio1)
    //   this.drawChartXArea(this.loadingXMinMax, this.chartData2.map(function (o) { return o.pc1 }), marginRatio2)
    //   this.drawChartYArea(this.loadingYMinMax, this.chartData2.map(function (o) { return o.pc2 }), marginRatio2)
    //   this.drawChartXArea(this.scoreXMinMax, this.chartData3.map(function (o) { return o.pc1 }), marginRatio2)
    //   this.drawChartYArea(this.scoreYMinMax, this.chartData3.map(function (o) { return o.pc2 }), marginRatio2)

    //   this.drawChartXYOrigin(this.loadingChart, this.chartData2)
    //   this.drawChartXYOrigin(this.scoreChart, this.chartData3)

    //   this.drawScoreChartCircle(this.scoreChart.axisX.origin, this.scoreChart.axisY.origin)
    // },
    /**
     * chart 중심 반경 원 그리기
     * @param {*} originX axisX origin
     * @param {*} originY axisY origin
     */
    // drawScoreChartCircle (originX, originY) {
    //   // const r = 4.0
    //   this.pFun.min = 0
    //   // this.pFun.max = 2 * Math.PI
    //   this.pFun.max = 2 * Math.PI
    //   this.pFun.xFunc = (t) => this.scoreEllipse.xradius * Math.cos(t) + this.scoreEllipse.mean[0]
    //   this.pFun.yFunc = (t) => this.scoreEllipse.yradius * Math.sin(t) + this.scoreEllipse.mean[1]
    //   this.pFun.style = {
    //     stroke: 'red'
    //   }
    //   this.scoreXMinMax.xMin = this.scoreEllipse.xmin
    //   this.scoreXMinMax.xMax = this.scoreEllipse.xmax
    //   this.scoreYMinMax.yMin = this.scoreEllipse.ymin
    //   this.scoreYMinMax.yMax = this.scoreEllipse.ymax
    // },
    /**
     * x축 차트 영역 계산
     * @param {Object} xMinMax x축 Min Max Object
     * @param {Array} values x축 value 배열
     * @param {Number} marginRatio margin 비율
     */
    // drawChartXArea (xMinMax, values, marginRatio) {
    //   let xMin = 0; let xMax = 0; let margin = 0
    //   xMax = Math.max(...values)
    //   xMin = Math.min(...values)
    //   margin = (xMax - xMin) * marginRatio
    //   xMinMax.xMin = xMin - margin
    //   xMinMax.xMax = xMax + margin
    // },
    /**
     * y축 차트 영역 계산
     * @param {Object} yMinMax y축 Min Max Object
     * @param {Array} values y축 value 배열
     * @param {Number} marginRatio margin 비율
     */
    // drawChartYArea (yMinMax, values, marginRatio) {
    //   let yMin = 0; let yMax = 100; let margin = 0
    //   yMax = Math.max(...values)
    //   yMin = Math.min(...values)
    //   margin = (yMax - yMin) * marginRatio
    //   yMinMax.yMin = yMin - margin
    //   yMinMax.yMax = yMax + margin
    // },
    /**
     * Next Step Button 클릭
     * Hoteling T2 step으로 단계를 넘깁니다.
     */
    clickNextStep () {
      // TODO check로직
      this.$emit('tab-selected', 2)
    }
    /**
     * null 값 check
     * @param {*} value check value
     */
    // isEmpty (value) {
    //   if (value === '' || value == null || value === undefined || (value != null && typeof value === 'object' && !Object.keys(value).length)) {
    //     return true
    //   } else {
    //     return false
    //   }
    // }
  },
  data () {
    return {
      cumulativePercent: 90, // Cumulative Percent data
      briqueChart: null // BriqueChart Component 객체
    }
  }
}
